
  // Define eagerBoot with initialization options and initialize promises with a resolved promise
  var eagerBoot = [() => (() => (__webpack_require__(75713))),() => (() => (__webpack_require__(5556)))];
  var promises = [];

  eagerBoot.forEach(function(initFunctionFactory, index) {
    // Invoke the factory function to get the initialization function
    const initFunction = initFunctionFactory();

    if (index === 0) {
      // Immediately execute the first initialization function
      initFunction();
      // If there's chunkEnsure logic for the first item, include it here
       
    } else {
      // For subsequent items, ensure all existing promises are resolved before execution
      if(promises.length > 0) {
         Promise.all(promises).then(function(){initFunction()});
      } else {
        initFunction();
      }
    }
  });
  